import React, { Component } from 'react';
import {
    Redirect,
    Link
} from "react-router-dom";
import InputRange from 'react-input-range';
import LineBar from './LineBar';
import Layout from './Layout';

class Calculate extends Component {
    constructor(props) {
        super(props);
     
        this.state = {
            avrNum: 500000,
            AvrCPM: 1.25,
            AdUnitsPP: 3,
            currentAdSet : 1,
            selectDisabled : false,
            redirect : false
        };

        this.handleChange = this.handleChange.bind( this ); 

    }

    handleChange = (event) => {
        // event.preventDefault();
        if(event.target.value === "contact"){  
            this.setState({
                redirect: true
            })
        }else{
            this.setState({ 
                currentAdSet: event.target.value,
                selectDisabled : true 
            });
            // this.props.fieldVal(this.state.avrNum, this.state.AvrCPM, this.state.AdUnitsPP, event.target.value);
        }
    };

    render() {
        if (this.state.redirect) {
            return <Redirect to="/contact" />;
        }
        return (
            <Layout>
                <div className="row justify-content-between">
                    <div className="col-md-5 mb-5">

                        <div className="range_slider mb-4">
                            <p>Current ad setup</p>
                            <select disabled={this.state.selectDisabled ? true : false} className="form-control btn-primary border-0 form-pink" value={this.state.currentAdSet} onChange={this.handleChange}>
                                <option value="1">Using Adsense/Adx</option>
                                <option value="2">3+ Demand partners</option>
                                <option value="contact">Other</option>
                            </select>
                        </div>

                        <div className="range_slider mb-4">
                            <p>Average page views per month</p>
                            <InputRange
                                maxValue={50000000}
                                minValue={0}
                                formatLabel={value => value.toLocaleString()}
                                className="input-range"
                                value={this.state.avrNum}
                                onChange={value => this.setState({ avrNum : value }) } />
                        </div>
                        
                        <div className="range_slider mb-4">
                            <p>Average CPM (USD)</p>
                            <InputRange
                                maxValue={10}
                                minValue={0}
                                step={0.10}
                                value={this.state.AvrCPM}
                                onChange={value => this.setState({ AvrCPM : parseFloat(value.toFixed(2)) })} />
                        </div>
                        
                        <div className="range_slider mb-4">
                            <p>Ad units per page</p>
                            <InputRange
                                maxValue={15}
                                minValue={0}
                                value={this.state.AdUnitsPP}
                                onChange={value => this.setState({ AdUnitsPP : value }) } />
                        </div>

                        <Link to="/contact" className="btn btn-primary border-0 btn-block">Get in-depth analysis</Link>
                    </div>
                    <div className="col-md-6 mb-5">
                        <LineBar avrNum={this.state.avrNum} AvrCPM={this.state.AvrCPM} AdUnitsPP={this.state.AdUnitsPP} currentAdSet={this.state.currentAdSet} />
                        {/* <LineBar /> */}
                    </div>
                </div>
            </Layout>
        );
    }
}

export default Calculate;